import classnames from 'classnames';
import type { ReactElement, ReactNode } from 'react';
import styles from './Tabs.module.scss';

export type TabLinkProps = {
  active?: boolean;
  children: ReactNode;
  href?: string;
};

export function TabLink(props: TabLinkProps): ReactElement {
  const { active, children, href } = props;
  return (
    <a
      href={href}
      className={classnames({
        [styles.activeTab]: !!active,
        [styles.inactiveTab]: !active
      })}
    >
      {children}
    </a>
  );
}
